import { combineReducers } from 'redux'

import dashboard from './dashboard/reducers'

const statisticsReducer = combineReducers({
  dashboard,
})

export default statisticsReducer
